import { Plugin } from '@ckeditor/ckeditor5-core';
import { toWidget } from '@ckeditor/ckeditor5-widget';
import InsertRelatedArticleCommand from './related-article-command';
export default class RelatedArticleEditing extends Plugin {
    init() {
        this.editor.commands.add('insertRelatedArticle', new InsertRelatedArticleCommand(this.editor));
        this._defineSchema();
        this._defineConverters();
    }
    _defineSchema() {
        const schema = this.editor.model.schema;
        schema.register('relatedArticle', {
            isObject: true,
            allowWhere: '$block',
            allowAttributes: 'postId',
        });
        schema.register('relatedArticleTitle', {
            isLimit: true,
            allowIn: 'relatedArticle',
            allowContentOf: '$block',
        });
        schema.register('relatedArticleDescription', {
            isLimit: true,
            allowIn: 'relatedArticle',
            allowContentOf: '$block',
        });
    }
    _defineConverters() {
        try {
            const conversion = this.editor.conversion;
            // Related article container
            conversion.for('upcast').elementToElement({
                model: (viewElement, { writer }) => {
                    return writer.createElement('relatedArticle', {
                        postId: viewElement.getAttribute('data-post-id'),
                    });
                },
                view: { name: 'x-related-article' },
            });
            conversion.for('dataDowncast').elementToElement({
                model: 'relatedArticle',
                view: (modelElement, { writer }) => {
                    return writer.createContainerElement('x-related-article', {
                        'data-post-id': modelElement.getAttribute('postId'),
                    });
                },
            });
            conversion.for('editingDowncast').elementToElement({
                model: 'relatedArticle',
                view: (model, { writer }) => {
                    const element = writer.createContainerElement('div', {
                        class: 'related-article',
                        'data-post-id': model.getAttribute('postId'),
                    });
                    return toWidget(element, writer, { label: 'related article' });
                },
            });
            // Related article title
            conversion.for('upcast').elementToElement({
                model: 'relatedArticleTitle',
                view: 'x-related-article-title',
            });
            conversion.for('dataDowncast').elementToElement({
                model: 'relatedArticleTitle',
                view: 'x-related-article-title',
            });
            conversion.for('editingDowncast').elementToElement({
                model: 'relatedArticleTitle',
                view: (model, { writer }) => {
                    const element = writer.createContainerElement('div', {
                        class: 'related-article__title',
                    });
                    return element;
                },
            });
            // Related article description
            conversion.for('upcast').elementToElement({
                model: 'relatedArticleDescription',
                view: 'x-related-article-description',
            });
            conversion.for('dataDowncast').elementToElement({
                model: 'relatedArticleDescription',
                view: 'x-related-article-description',
            });
            conversion.for('editingDowncast').elementToElement({
                model: 'relatedArticleDescription',
                view: (model, { writer }) => {
                    const element = writer.createContainerElement('div', {
                        class: 'related-article__description',
                    });
                    return element;
                },
            });
        }
        catch (e) {
            console.error(e);
        }
    }
}
